import React, { Suspense, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { AppLayout, Sidebar } from "@wayfarer/components";
import { Sidebar as SidebarEnrichment } from "./app/routes/Sidebar";
import { SidebarPages } from "./app/routes/config/SidebarPages";
import LoadingFallback from "./LoadingFallback";
import AscendHeader from "./components/AscendHeader";

const MINI_WIDTH = "64px";
const FULL_WIDTH = "256px";

const Shell = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const wrapperWidth = useMemo(
    () => ({ width: sidebarOpen ? FULL_WIDTH : MINI_WIDTH }),
    [sidebarOpen],
  );

  const sidebarStyle = useMemo<React.CSSProperties>(
    () => ({
      width: sidebarOpen ? "auto" : MINI_WIDTH,
      backgroundColor: "white",
      boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.12)",
      position: "absolute",
      height: "93%",
    }),
    [sidebarOpen],
  );

  const sidebarContent = useMemo(
    () => <SidebarEnrichment pages={SidebarPages} mini={!sidebarOpen} />,
    [sidebarOpen],
  );

  return (
    <>
      <AppLayout
        header={<AscendHeader />}
        sidebar={
          <div style={wrapperWidth}>
            <Sidebar
              style={sidebarStyle}
              open={sidebarOpen}
              onToggle={setSidebarOpen}
              openContent={sidebarContent}
              closedContent={sidebarContent}
            />
          </div>
        }
        main={
          <Suspense fallback={<LoadingFallback />}>
            <Outlet />
          </Suspense>
        }
      />
    </>
  );
};

export default Shell;
